import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { Print } from "./Print"
import { SettleDrawer } from "./SettleDrawer"
import { OfferPrint } from "./OfferPrint"
import { SalePrint } from "./SalePrint"
import { useMaintenanceModel } from "../maintenanceModel"

export default () => {
    const { offerPrint, salePrint } = useMaintenanceModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            <Print />
            <SettleDrawer />
            {offerPrint && <OfferPrint />}
            {salePrint && <SalePrint />}
        </>
    )
}